const DATA_SAVED = "extragestor/busquedas/DATA_SAVED";
const RESET_DATA_SAVED = "extragestor/busquedas/RESET_DATA_SAVED";
const FETCH_ALUMNOS = "extragestor/busquedas/FETCH_ALUMNOS";
const FETCH_COLEGIOS = "extragestor/busquedas/FETCH_COLEGIOS";
const FETCH_ACTIVIDADES = "extragestor/busquedas/FETCH_ACTIVIDADES";
const RESET = "extragestor/busquedas/RESET";
const RESET_SEARCH_ACTIVIDADES =
  "extragestor/busquedas/RESET_SEARCH_ACTIVIDADES";
const RESET_SEARCH_ALUMNOS = "extragestor/busquedas/RESET_SEARCH_ALUMNOS";

const FETCH_SEARCH_ESCUELA_NOMBRES =
  "extragestor/busquedas/FETCH_SEARCH_ESCUELA_NOMBRES";
const FETCH_SEARCH_ESCUELA_RESGUARDO =
  "extragestor/busquedas/FETCH_SEARCH_ESCUELA_RESGUARDO";
const FETCH_SEARCH_ESCUELA_COLEGIOS =
  "extragestor/busquedas/FETCH_SEARCH_ESCUELA_COLEGIOS";
const RESET_SEARCH_ESCUELAS = "extragestor/busquedas/RESET_SEARCH_ESCUELAS";

/*---*/
export {
  DATA_SAVED,
  RESET_DATA_SAVED,
  FETCH_ALUMNOS,
  FETCH_COLEGIOS,
  FETCH_ACTIVIDADES,
  RESET,
  RESET_SEARCH_ACTIVIDADES,
  RESET_SEARCH_ALUMNOS,
  FETCH_SEARCH_ESCUELA_NOMBRES,
  FETCH_SEARCH_ESCUELA_RESGUARDO,
  FETCH_SEARCH_ESCUELA_COLEGIOS,
  RESET_SEARCH_ESCUELAS
};



// WEBPACK FOOTER //
// ./src/ducks/busquedas/types.js